module.exports = __webpack_public_path__ + "static/009-5287185ff254aa520325a57f305a081e.jpg";